module.exports = new __parcel__URL__("open-hihat_12.a95c984b.mp3").toString();